/* eslint-disable no-restricted-syntax */
/* eslint-disable no-console */

import _ from 'lodash';
import { SLTXFormatRootFile, SLTXFormatRootFileGroup } from '../../fileFormats/sltx/sltx';
import { RulesEvaluation } from './rulesEvaluation';
import { TreeOptionSelections } from '../data/optionsSelection';
import { ModelRuleData, ModelRuleGroupData } from './modelRuleData';
import { ModelGroupInfo } from '../../fileFormats/sltx/modelGroupInfo';

export class RulesEvaluationFilter {

  public static evaluateRule(
    // The rule to evaluate
    filteringRule : ModelRuleData,
    // The tree to show the user. At first, will be the entire tree that comes from the file
    originGroups : SLTXFormatRootFileGroup[],
    // The current selection state
    optionsSelectionState: TreeOptionSelections,
    // The details about the model
    sltxFile : SLTXFormatRootFile,
  ) : SLTXFormatRootFileGroup[] {

    if (filteringRule === undefined || filteringRule.ruleDataFilter === undefined) {
      return originGroups;
    }

    const { conditions, actions } = filteringRule.ruleDataFilter;

    // If there are no conditions, return the origin groups
    if (conditions.length === 0) {
      // console.warn("There are no conditions in the rule, so it won't filter anything");
      return originGroups;
    }

    // Check if the conditions defined are fulfilled
    const allConditionsFulfilled = RulesEvaluation.checkIfConditionsAreFulfilled(
      conditions,
      optionsSelectionState,
      sltxFile,
    );

    if (allConditionsFulfilled === false) {
      // If the conditions are not fulfilled, return the original groups
      return originGroups;
    }

    // If the conditions are fulfilled, then we need to filter the groups
    const filteredGroups = this.filterGroups(
      actions,
      originGroups,
      sltxFile,
    );

    return filteredGroups;
  }

  private static filterGroups(
    actions: ModelRuleGroupData[],
    originGroups: SLTXFormatRootFileGroup[],
    sltxFile: SLTXFormatRootFile,
  ) : SLTXFormatRootFileGroup[] {

    // Create a copy of the origin groups and modify it as needed
    const filteredGroups = _.cloneDeep(originGroups);

    // Go through the groups in the model and check if they should be filtered

    const sltxFileGroups = sltxFile.groups;

    if (sltxFileGroups === undefined) {
      console.error('SLTXFile Groups are undefined');
      return filteredGroups;
    }

    // Go through all the groups in the SLTX file
    for (const sltxFileGroup of sltxFileGroups) {

      // Check if this group is part of the filtering rule
      const ruleAction = actions.find((action) => action.groupID === sltxFileGroup.id);

      if (ruleAction === undefined) {
        // This group is not part of the filtering rule
        // So we can skip it
        // eslint-disable-next-line no-continue
        continue;
      }

      // This group is part of the filtering rule
      // Locate the group in the filtered groups
      const groupToFilter = filteredGroups.find((group) => group.id === sltxFileGroup.id);

      if (groupToFilter === undefined) {
        console.error('Could not find group in filtered groups');
        // eslint-disable-next-line no-continue
        continue;
      }

      // Filter the options in the group
      const groupToFilterOptions = ModelGroupInfo.getGroupRootOptions(groupToFilter);
      groupToFilterOptions.splice(0, Infinity, ...groupToFilterOptions.filter(
        (option) => ruleAction.options.includes(option.id),
      ));
    }

    // Return the filtered groups
    return filteredGroups;
  }
}
